Object.defineProperty(exports, '__esModule', {
  value: true
});
var createFakeEvent = function createFakeEvent(name, value) {
  return {
    target: {
      type: "text",
      value: value,
      name: name
    },
    persist: function persist() {}
  };
};
exports.createFakeEvent = createFakeEvent;